// import React from "react";
// import { Box } from "@mui/material";
// import { NavBar } from "../navbar/navbar";
// import { FooterBar } from "../footer/footerBar";


// export const Layout = ({ children }) => {
//   return (
//     <>
//       <NavBar />
//       <Box>{children}</Box>
//       <FooterBar/>
//     </>
//   );
// };


import React from "react";
import { Box } from "@mui/material";
import { useLocation } from "react-router-dom";

import { NavBar } from "../navbar/navbar";
import { FooterBar } from "../footer/footerBar";

export const Layout = ({ children }) => {
  const location = useLocation();

  // routes where navbar/footer should be hidden
  const hideLayoutRoutes = ["/ekyc-callback"];

  const shouldHideLayout = hideLayoutRoutes.includes(
    location.pathname
  );

  return (
    <>
      {!shouldHideLayout && <NavBar />}

      <Box>{children}</Box>

      {!shouldHideLayout && <FooterBar />}
    </>
  );
};